import { ReactElement, useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'
import { paymentSecurityModalContainerId } from 'const/modalContainerId'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'

import getMFEConfig from 'helpers/getMFEConfig'
import PaymentSecurity from '@account-services-mfe/payment-security'
import i18n from 'strings/i18n'
import config from 'const/config'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'

const PaymentSecurityModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleEscapeAndModalHeader = () => {
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
    handleCloseModal()
  }

  return (
    <SlideInModalPortal
      containerId={paymentSecurityModalContainerId(selectedAccount)}
      escapeModalHandler={handleEscapeAndModalHeader}
      id={`ps-slide-in-modal-${selectedAccount}`}
      isOpen={modalId === 'PaymentSecurity'}
      modalTriggerId={modalTriggerId}
      header={
        <ModalHeader
          closeModal={handleEscapeAndModalHeader}
          content={i18n({ button: 'paymentSecurity' }) as string}
          data-test="payment-security-modal-header"
          dataReason="x button"
          dataType="payment security"
          headerRef={headerRef}
        />
      }
    >
      <PaymentSecurity
        authorizeAONUrl={config.AON_AUTHORIZE_URL}
        config={mfeConfig}
        selectedAccountId={selectedAccount}
        handleClose={handleCloseModal}
        features={{
          brandRefreshPhase: getBrandRefreshPhase()
        }}
      />
    </SlideInModalPortal>
  )
}

export default PaymentSecurityModal
